import { Space, Button, TableActions } from '@/components/ui'
import { Event } from '@/types/events'
import { Icon } from '@/components/icons'

interface EventActionsCellProps {
  event: Event
  viewMode: 'list' | 'report'
  onEdit?: (event: Event) => void
  onDelete?: (event: Event) => void
  onView?: (event: Event) => void
}

export function EventActionsCell({
  event,
  viewMode,
  onEdit,
  onDelete,
  onView,
}: EventActionsCellProps) {
  if (viewMode === 'report') {
    return (
      <Button variant="tertiary" size="small" onClick={() => onView?.(event)}>
        View
      </Button>
    )
  }

  return (
    <TableActions
      actions={[
        {
          key: 'edit',
          icon: <Icon name="edit" size={20} />,
          onClick: () => onEdit?.(event),
          ariaLabel: 'Edit event',
        },
        {
          key: 'delete',
          icon: <Icon name="delete" size={20} />,
          onClick: () => onDelete?.(event),
          ariaLabel: 'Delete event',
          danger: true,
        },
      ]}
    />
  )
}
